function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import has from 'lodash/has';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import BackToIntegrationApp from 'components/BackToIntegrationApp';
import PartnerApplication from 'components/PartnerApplication';
import App, { AlertsBus } from 'modules/App';
import { LogoutBtn } from 'modules/Account';
import messages from '../../messages';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import DataAccessConsents from './DataAccessConsents';
import PartnerApplicationDisclaimers from './PartnerApplicationDisclaimers';
import styles from './PartnerIntegration.pcss';
const Actions = ({ scopes, returnUrl })=>{
    const account = useSelector(selectors.account);
    const isAcceptConsentsInProgress = useSelector(selectors.isAcceptConsentsInProgress);
    const isRejectConsentsInProgress = useSelector(selectors.isRejectConsentsInProgress);
    const hasPostConsentsErrors = useSelector(selectors.hasPostConsentsErrors);
    const prevIsAcceptConsentsInProgressRef = useRef(isAcceptConsentsInProgress);
    const prevIsRejectConsentsInProgressRef = useRef(isRejectConsentsInProgress);
    const [isApproveConsentsSucceed, setIsAcceptConsentsSucceed] = useState(false);
    const [isRejectConsentsSucceed, setIsRejectConsentsSucceed] = useState(false);
    const onAccept = useAction(actions.acceptConsents, scopes, returnUrl);
    const onReject = useAction(actions.rejectConsents, returnUrl);
    useEffect(()=>{
        if (prevIsAcceptConsentsInProgressRef.current !== isAcceptConsentsInProgress) {
            if (!isAcceptConsentsInProgress && !hasPostConsentsErrors) {
                setIsAcceptConsentsSucceed(true);
            }
            prevIsAcceptConsentsInProgressRef.current = isAcceptConsentsInProgress;
        }
    }, [
        isAcceptConsentsInProgress,
        hasPostConsentsErrors
    ]);
    useEffect(()=>{
        if (prevIsRejectConsentsInProgressRef.current !== isRejectConsentsInProgress) {
            if (!isRejectConsentsInProgress && !hasPostConsentsErrors) {
                setIsRejectConsentsSucceed(true);
            }
            prevIsRejectConsentsInProgressRef.current = isRejectConsentsInProgress;
        }
    }, [
        isRejectConsentsInProgress,
        hasPostConsentsErrors
    ]);
    const isActionsDisabled = !account || !has(account, 'encryptedHolderPassphrase') || !has(account, 'holderUID');
    return /*#__PURE__*/ _jsxs("div", {
        className: "row",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.labels.cancel,
                className: "btn--block",
                isInProgress: isRejectConsentsInProgress || isRejectConsentsSucceed,
                isDisabled: isActionsDisabled || isAcceptConsentsInProgress || isApproveConsentsSucceed,
                onClick: onReject
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.labels.integrate,
                className: "btn--block btn--filled",
                isInProgress: isAcceptConsentsInProgress || isApproveConsentsSucceed,
                isDisabled: isActionsDisabled || isRejectConsentsInProgress || isRejectConsentsSucceed,
                onClick: onAccept
            })
        ]
    });
};
const PartnerIntegration = ({ scopes, returnUrl })=>{
    const client = useSelector(selectors.client);
    const isInitializeInProgress = useSelector(selectors.isInitializeInProgress);
    const hasInitializeErrors = useSelector(selectors.hasInitializeErrors);
    const requireConsent = useSelector(App.selectors.requireConsent);
    if (isInitializeInProgress || hasInitializeErrors || !requireConsent) {
        if (hasInitializeErrors) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.errorHeader,
                        children: [
                            /*#__PURE__*/ _jsx(BackToIntegrationApp, {
                                to: returnUrl
                            }),
                            /*#__PURE__*/ _jsx(LogoutBtn, {
                                className: "mb-6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(AlertsBus, {
                        className: "mb-5"
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(AlertsBus, {
            className: "mb-5"
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "pageContentBox",
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "pageHeader",
                children: /*#__PURE__*/ _jsx("h1", {
                    className: "text--h2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.integratingWithAnApp))
                })
            }),
            /*#__PURE__*/ _jsx(AlertsBus, {
                className: "mb-5"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.application,
                children: /*#__PURE__*/ _jsx(PartnerApplication, {
                    logoUri: client.logoUri,
                    appName: client.appName,
                    companyName: client.companyName
                })
            }),
            /*#__PURE__*/ _jsx(DataAccessConsents, {
                requestedScopes: scopes
            }),
            /*#__PURE__*/ _jsx(PartnerApplicationDisclaimers, {}),
            /*#__PURE__*/ _jsx(Actions, {
                scopes: scopes,
                returnUrl: returnUrl
            })
        ]
    });
};
export default withStyles(styles)(PartnerIntegration);
